import { ca } from '@cian/analytics';

export function trackCardTeaserShow(offerId: number, position: number) {
  ca('teaser', {
    product: {
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
      },
      position,
      screen: 'ListingFavorites',
      block: 'FavoritesScreen',
    },
  });
}
